export const serviceOrValueGroupFields = (t)=>({
        maxChargesLimit: {
            editor: 'integer',
            label: t.servicesBillingLimitCanBeBilledLabel(),
            validationError: t.singleValueValidationError()
        }
    });
export const serviceOrValueGroupTexts = (t, connector)=>({
        apply: t.applyButton(),
        connector
    });
